import { render, staticRenderFns } from "./largeScreen.vue?vue&type=template&id=a62ae744&scoped=true"
import script from "./largeScreen.vue?vue&type=script&lang=js"
export * from "./largeScreen.vue?vue&type=script&lang=js"
import style0 from "./largeScreen.vue?vue&type=style&index=0&id=a62ae744&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a62ae744",
  null
  
)

export default component.exports